import get from 'lodash/get';
import { 
  GET_LIST_MATERIAL_CATEGORY, 
  GET_LIST_MATERIAL_CATEGORY_SUCCESS, 
  GET_LIST_MATERIAL_CATEGORY_FAILURE,
  GET_ALL_MATERIALS,
  GET_ALL_MATERIALS_SUCCESS,
  GET_ALL_MATERIALS_FAILURE,
  GENERATE_MATERIAL_REPORT,
  GENERATE_MATERIAL_REPORT_SUCCESS,
  GENERATE_MATERIAL_REPORT_FAILURE,
  CLEAR_GENERATE_MATERIAL_REPORT,
  GET_MATERIAL_REPORT_VERSIONS,
  GET_MATERIAL_REPORT_VERSIONS_SUCCESS,
  GET_MATERIAL_REPORT_VERSIONS_FAILURE,
  GENERATE_MATERIAL_REGISTRY_REPORT,
  GENERATE_MATERIAL_REGISTRY_REPORT_SUCCESS,
  GENERATE_MATERIAL_REGISTRY_REPORT_FAILURE,
  CLEAR_MATERIAL_REGISTRY_REPORT,
  GET_REGISTRY_REPORT_VERSIONS,
  GET_REGISTRY_REPORT_VERSIONS_SUCCESS,
  GET_REGISTRY_REPORT_VERSIONS_FAILURE,
  GET_INSPECTION_PERSONNEL_DOCUMENTS,
  GET_INSPECTION_PERSONNEL_DOCUMENTS_SUCCESS,
  GET_INSPECTION_PERSONNEL_DOCUMENTS_FAILURE,
  GET_REGISTRY_BOOK_VERSIONS,
  GET_REGISTRY_BOOK_VERSIONS_SUCCESS,
  GET_REGISTRY_BOOK_VERSIONS_FAILURE,
  GET_MATERIAL_REGISTRY_REPORT_VERSIONS,
  GET_MATERIAL_REGISTRY_REPORT_VERSIONS_SUCCESS,
  GET_MATERIAL_REGISTRY_REPORT_VERSIONS_FAILURE,
  GET_MATERIAL_TRACEABILITY_ALL_SUMMARY,
  GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_SUCCESS,
  GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_FAILURE,
  GET_MATERIAL_TRACEABILITY_ALL_DATA,
  GET_MATERIAL_TRACEABILITY_ALL_DATA_SUCCESS,
  GET_MATERIAL_TRACEABILITY_ALL_DATA_FAILURE
} from "./types";

const initialState = {
  isMaterialCategoryLoading: false,
  materialCategories: [],
  isMaterialsLoading: false,
  materials: {}, // Store materials by key: `${project_id}_${project_type_id}_${pipe_id}`
  // Generate Material Report state
  generateMaterialReportLoading: false,
  generateMaterialReportSuccess: false,
  generateMaterialReportError: null,
  generateMaterialReportData: null,
  // Material Report Versions state
  materialReportVersionsLoading: false,
  materialReportVersions: [],
  materialReportVersionsError: null,
  // Material Registry Report state (Equipment/Consumable)
  materialRegistryReportLoading: false,
  materialRegistryReportSuccess: false,
  materialRegistryReportError: null,
  materialRegistryReportData: null,
  // Registry Report Versions state (new API) - grouped by report type
  registryReportVersionsLoading: false,
  registryReportVersions: {},
  registryReportVersionsError: null,
  // Inspection Personnel Documents state (QC Inspection Personnel)
  inspectionPersonnelDocumentsLoading: false,
  inspectionPersonnelDocuments: {},
  inspectionPersonnelDocumentsError: null,
  // Registry Book Versions state (previously generated registry books)
  registryBookVersionsLoading: false,
  registryBookVersions: [],
  registryBookVersionsError: null,
  // Material Registry Report Versions state (for /material-registry-documents endpoint)
  materialRegistryReportVersionsLoading: false,
  materialRegistryReportVersions: {},
  materialRegistryReportVersionsError: null,
  // Material Traceability All Summary (Pipe Dashboard)
  materialTraceabilitySummary: null,
  materialTraceabilitySummaryLoading: false,
  materialTraceabilitySummaryError: null,
  // Material Traceability All Data (Pipe Dashboard Table)
  materialTraceabilityAllDataLoading: false,
  materialTraceabilityAllData: {},
  materialTraceabilityAllTotal: 0,
  materialTraceabilityAllDataError: null,
};

const materialsDataReducer = (state = initialState, action) => {
  switch (action.type) {
    // Material Category Cases
    case GET_LIST_MATERIAL_CATEGORY: {
      return {
        ...state,
        isMaterialCategoryLoading: true,
      };
    }
    case GET_LIST_MATERIAL_CATEGORY_SUCCESS: {
      const responseData = get(action, 'responseData', []);
      return {
        ...state,
        materialCategories: responseData,
        isMaterialCategoryLoading: false
      };
    }
    case GET_LIST_MATERIAL_CATEGORY_FAILURE: {
      return {
        ...state,
        isMaterialCategoryLoading: false
      };
    }
    
    // Get All Materials Cases
    case GET_ALL_MATERIALS: {
      return {
        ...state,
        isMaterialsLoading: true,
      };
    }
    case GET_ALL_MATERIALS_SUCCESS: {
      const responseData = get(action, 'responseData', {});
      const cacheKey = get(action, 'cacheKey', '');
      
      return {
        ...state,
        materials: {
          ...state.materials,
          [cacheKey]: responseData
        },
        isMaterialsLoading: false
      };
    }
    case GET_ALL_MATERIALS_FAILURE: {
      return {
        ...state,
        isMaterialsLoading: false
      };
    }
    
    // Generate Material Report Cases
    case GENERATE_MATERIAL_REPORT: {
      return {
        ...state,
        generateMaterialReportLoading: true,
        generateMaterialReportSuccess: false,
        generateMaterialReportError: null,
        generateMaterialReportData: null
      };
    }
    case GENERATE_MATERIAL_REPORT_SUCCESS: {
      const responseData = get(action, 'payload', null);
      return {
        ...state,
        generateMaterialReportLoading: false,
        generateMaterialReportSuccess: true,
        generateMaterialReportError: null,
        generateMaterialReportData: responseData
      };
    }
    case GENERATE_MATERIAL_REPORT_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        generateMaterialReportLoading: false,
        generateMaterialReportSuccess: false,
        generateMaterialReportError: error,
        generateMaterialReportData: null
      };
    }
    case CLEAR_GENERATE_MATERIAL_REPORT: {
      return {
        ...state,
        generateMaterialReportLoading: false,
        generateMaterialReportSuccess: false,
        generateMaterialReportError: null,
        generateMaterialReportData: null
      };
    }
    
    // Get Material Report Versions Cases
    case GET_MATERIAL_REPORT_VERSIONS: {
      return {
        ...state,
        materialReportVersionsLoading: true,
        materialReportVersionsError: null
      };
    }
    case GET_MATERIAL_REPORT_VERSIONS_SUCCESS: {
      const responseData = get(action, 'payload', []);
      return {
        ...state,
        materialReportVersionsLoading: false,
        materialReportVersions: responseData,
        materialReportVersionsError: null
      };
    }
    case GET_MATERIAL_REPORT_VERSIONS_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        materialReportVersionsLoading: false,
        materialReportVersions: [],
        materialReportVersionsError: error
      };
    }
    
    // Generate Material Registry Report Cases (Equipment/Consumable)
    case GENERATE_MATERIAL_REGISTRY_REPORT: {
      return {
        ...state,
        materialRegistryReportLoading: true,
        materialRegistryReportSuccess: false,
        materialRegistryReportError: null,
        materialRegistryReportData: null
      };
    }
    case GENERATE_MATERIAL_REGISTRY_REPORT_SUCCESS: {
      const responseData = get(action, 'payload', null);
      return {
        ...state,
        materialRegistryReportLoading: false,
        materialRegistryReportSuccess: true,
        materialRegistryReportError: null,
        materialRegistryReportData: responseData
      };
    }
    case GENERATE_MATERIAL_REGISTRY_REPORT_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        materialRegistryReportLoading: false,
        materialRegistryReportSuccess: false,
        materialRegistryReportError: error,
        materialRegistryReportData: null
      };
    }
    case CLEAR_MATERIAL_REGISTRY_REPORT: {
      return {
        ...state,
        materialRegistryReportLoading: false,
        materialRegistryReportSuccess: false,
        materialRegistryReportError: null,
        materialRegistryReportData: null
      };
    }
    
    // Get Registry Report Versions Cases (new API)
    case GET_REGISTRY_REPORT_VERSIONS: {
      return {
        ...state,
        registryReportVersionsLoading: true,
        registryReportVersionsError: null
      };
    }
    case GET_REGISTRY_REPORT_VERSIONS_SUCCESS: {
      const responseData = get(action, 'payload', []);
      return {
        ...state,
        registryReportVersionsLoading: false,
        registryReportVersions: responseData,
        registryReportVersionsError: null
      };
    }
    case GET_REGISTRY_REPORT_VERSIONS_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        registryReportVersionsLoading: false,
        registryReportVersions: {},
        registryReportVersionsError: error
      };
    }
    
    // Get Inspection Personnel Documents Cases (QC Inspection Personnel)
    case GET_INSPECTION_PERSONNEL_DOCUMENTS: {
      return {
        ...state,
        inspectionPersonnelDocumentsLoading: true,
        inspectionPersonnelDocumentsError: null
      };
    }
    case GET_INSPECTION_PERSONNEL_DOCUMENTS_SUCCESS: {
      const responseData = get(action, 'payload', {});
      return {
        ...state,
        inspectionPersonnelDocumentsLoading: false,
        inspectionPersonnelDocuments: responseData,
        inspectionPersonnelDocumentsError: null
      };
    }
    case GET_INSPECTION_PERSONNEL_DOCUMENTS_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        inspectionPersonnelDocumentsLoading: false,
        inspectionPersonnelDocuments: {},
        inspectionPersonnelDocumentsError: error
      };
    }
    
    // Get Registry Book Versions Cases (previously generated registry books)
    case GET_REGISTRY_BOOK_VERSIONS: {
      return {
        ...state,
        registryBookVersionsLoading: true,
        registryBookVersionsError: null
      };
    }
    case GET_REGISTRY_BOOK_VERSIONS_SUCCESS: {
      const responseData = get(action, 'payload', []);
      return {
        ...state,
        registryBookVersionsLoading: false,
        registryBookVersions: responseData,
        registryBookVersionsError: null
      };
    }
    case GET_REGISTRY_BOOK_VERSIONS_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        registryBookVersionsLoading: false,
        registryBookVersions: [],
        registryBookVersionsError: error
      };
    }
    
    // Get Material Registry Report Versions Cases (for /material-registry-documents endpoint)
    case GET_MATERIAL_REGISTRY_REPORT_VERSIONS: {
      return {
        ...state,
        materialRegistryReportVersionsLoading: true,
        materialRegistryReportVersionsError: null
      };
    }
    case GET_MATERIAL_REGISTRY_REPORT_VERSIONS_SUCCESS: {
      const responseData = get(action, 'payload', []);
      return {
        ...state,
        materialRegistryReportVersionsLoading: false,
        materialRegistryReportVersions: responseData,
        materialRegistryReportVersionsError: null
      };
    }
    case GET_MATERIAL_REGISTRY_REPORT_VERSIONS_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        materialRegistryReportVersionsLoading: false,
        materialRegistryReportVersions: {},
        materialRegistryReportVersionsError: error
      };
    }

    // Material Traceability All Summary Cases (Pipe Dashboard)
    case GET_MATERIAL_TRACEABILITY_ALL_SUMMARY: {
      return {
        ...state,
        materialTraceabilitySummaryLoading: true,
        materialTraceabilitySummary: null,
        materialTraceabilitySummaryError: null
      };
    }
    case GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_SUCCESS: {
      const payload = get(action, 'payload', null);
      return {
        ...state,
        materialTraceabilitySummaryLoading: false,
        materialTraceabilitySummary: payload,
        materialTraceabilitySummaryError: null
      };
    }
    case GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        materialTraceabilitySummaryLoading: false,
        materialTraceabilitySummary: null,
        materialTraceabilitySummaryError: error
      };
    }

    // Material Traceability All Data Cases (Pipe Dashboard Table)
    case GET_MATERIAL_TRACEABILITY_ALL_DATA: {
      return {
        ...state,
        materialTraceabilityAllDataLoading: true,
        materialTraceabilityAllDataError: null
      };
    }
    case GET_MATERIAL_TRACEABILITY_ALL_DATA_SUCCESS: {
      const data = get(action, 'payload.data', {});
      const total = get(action, 'payload.total', 0);
      return {
        ...state,
        materialTraceabilityAllDataLoading: false,
        materialTraceabilityAllData: typeof data === 'object' && data !== null ? data : {},
        materialTraceabilityAllTotal: total,
        materialTraceabilityAllDataError: null
      };
    }
    case GET_MATERIAL_TRACEABILITY_ALL_DATA_FAILURE: {
      const error = get(action, 'error', 'An error occurred');
      return {
        ...state,
        materialTraceabilityAllDataLoading: false,
        materialTraceabilityAllData: {},
        materialTraceabilityAllTotal: 0,
        materialTraceabilityAllDataError: error
      };
    }
    
    default: {
      return state;
    }
  }
};

export default materialsDataReducer;

